import { useState } from 'react';
import ListWithShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';
//import { AccordionBlueUpArrow,
//TrashIcon,
//TrashIconDisable, } from '../../../../../../img/findcare/FindCareSVG';
import './facilityView.scss';
import { Accordion } from 'react-bootstrap';
//import '../../../../association.scss';
//import {AvatarFacilitySVG} from '../../../../../../img/SearchIndicatorSVG';
//import DoctorsPanel from '../FacilityView/DoctorsPanel/DoctorsPanel';
//import ShowMoreLess from 'src/Admin/components/ListWithShowMoreLess';
//import DoctorViewListItem from './DoctorViewListItem';
import FacilitiesViewListItem from '../FacilitiesViewListItem';

const FacilityViewPanel = ({
  selectedFacilities = [],
  onTrashButtonClickHandler = null,
  editAffiliatedRecords,
  allowDoctorSelection,
  selectedDoctor,
  setSelectedDoctor,
  onAddAllRecordsSameTaxId,
  selectedAllFacilitiesOfSameTaxId,
}) => {
  const [showMoreFacilities, setShowMoreFacilities] = useState(false);
  //const [idx, setIdx] = useState([]);
  const [doctorAllData, setDoctorAllData] = useState({});
  //const [ selectedDoctor, setSelectedDoctor ] = useState( null );
  //const [showMoreDoctors, setShowMoreDoctors] = useState(false);

  const onDoctorTrashButtonClickHandler = (e, facilityOid, deleteDoctor) => {
    console.log('onDoctorTrashButtonClickHandler');
    e.stopPropagation();
    console.log(
      'onDoctorTrashButtonClickHandler selectedDoctor ',
      Object.prototype.hasOwnProperty.call(selectedDoctor, facilityOid),
    );
    if (Object.prototype.hasOwnProperty.call(selectedDoctor, facilityOid)) {
      let tempObj = { ...selectedDoctor };
      const filteredObj = [selectedDoctor]
        .map((item) => item[facilityOid] || null)
        .filter((e1) => e1 !== null)
        .map((ele) =>
          ele
            .map((doc) => doc)
            .filter((del) => del.PhysicainOid !== deleteDoctor.PhysicainOid),
        );
      console.log('onDoctorTrashButtonClickHandler filteredObj', filteredObj);
      const finalObj = { [facilityOid]: filteredObj[0] };
      console.log('onDoctorTrashButtonClickHandler finalObj', finalObj);
      tempObj = Object.assign(tempObj, finalObj);
      setSelectedDoctor(tempObj);
    }
  };

  //const RenderDoctorListItem = ({data}) => {
  //console.log("DATA+++++++", data);
  //const doctor = data;
  //return <DoctorViewListItem
  //doctor={doctor}
  ////onDeleteClick={( e ) => employerProps.onEmpTrashButtonClickHandler( e, blob.oid, client.oid, client )}
  //onDeleteClick={( e ) => onDoctorTrashButtonClickHandler(e, doctor.FacilityOid, doctor)}
  ///>;
  //}

  const onSelectedDoctorHandler = (selectedDocLists, facilityOID) => {
    console.log('onSelectedDoctorHandler selectedDocLists', selectedDocLists);
    console.log('onSelectedDoctorHandler facilityOID', facilityOID);
    if (facilityOID) {
      if (selectedDocLists.length > 0) {
        const createDocObj = {
          [selectedDocLists[0].FacilityOid]: selectedDocLists,
        };
        let tempObj = { ...selectedDoctor };
        tempObj = Object.assign(tempObj, createDocObj);
        setSelectedDoctor(tempObj);
      } else {
        if (Object.prototype.hasOwnProperty.call(selectedDoctor, facilityOID)) {
          const tempObj = { ...selectedDoctor };
          delete tempObj[facilityOID];
          setSelectedDoctor(tempObj);
        }
      }
    } else {
      setSelectedDoctor([...selectedDocLists]);
    }
  };

  const onUnSelectedDocHandler = (unSelectedDoc) => {
    console.log('onUnSelectedDocHandler unSelectedDoc', unSelectedDoc);
  };

  console.log('selectedDoctor++++++++++', selectedDoctor);
  const sortedSelectedFacilities =
    selectedFacilities &&
    selectedFacilities.sort((a, b) => {
      return a.TaxId - b.TaxId;
    });

  const RenderFacilitiesListItem = ({ data, index }) => {
    return (
      <FacilitiesViewListItem
        data={data}
        index={index}
        selectedDoctors={selectedDoctor}
        doctorAllData={doctorAllData}
        setDoctorAllData={setDoctorAllData}
        allowDoctorSelection={allowDoctorSelection}
        onSelectedDocHandler={onSelectedDoctorHandler}
        onUnSelectedDocHandler={onUnSelectedDocHandler}
        onTrashButtonClickHandler={onTrashButtonClickHandler}
        editAffiliatedRecords={editAffiliatedRecords}
        onDoctorTrashButtonClickHandler={onDoctorTrashButtonClickHandler}
        onAddAllRecordsSameTaxId={onAddAllRecordsSameTaxId}
        selectedAllFacilitiesOfSameTaxId={selectedAllFacilitiesOfSameTaxId}
      />
    );
  };

  console.log('selectedDoctor========', selectedDoctor);
  console.log(
    'FacilityViewPanel selectedFacilities========',
    selectedFacilities,
  );

  return sortedSelectedFacilities?.length > 0 ? (
    <Accordion>
      <ListWithShowMoreLess
        data={sortedSelectedFacilities}
        RenderItemComponent={RenderFacilitiesListItem}
        showMore={showMoreFacilities}
        setShowMore={setShowMoreFacilities}
        showMoreLabel={'Facilities'}
      />
    </Accordion>
  ) : null;
};

export default FacilityViewPanel;
